<template>
    <div class="filedsContainer">

        <div class="head">
            <div class="tabs">
                <el-tabs v-model="activeName" >
                    <el-tab-pane label="资质" name="first">
                    </el-tab-pane>
                    <el-tab-pane label="商品" name="second">
                    </el-tab-pane>
                    <el-tab-pane label="订单" name="third">
                    </el-tab-pane>
                    <el-tab-pane label="售后单据" name="fourth">
                    </el-tab-pane>
                </el-tabs>
            </div>
            <div class="footer">
                <el-button type="primary" size="mini" @click="submit">提交</el-button>
                <el-button size="mini" @click="back">返回</el-button>
            </div>
        </div>
        <div class="body">
            <div class="chlidren">
                <credentials v-if="activeName == 'first'" />
                <goods v-if="activeName == 'second'" />
                <order v-if="activeName == 'third'" />
                <afterSales v-if="activeName == 'fourth'" />
            </div>
        </div>
    </div>
</template>
<script>
import credentials from "./credentials.vue";
import goods from "./goods.vue";
import order from "./order.vue";
import afterSales from "./afterSales.vue";

import { 
    saveCheckRecordDetails
} from "@/api/shopmange";
export default {
    name: "QAuditDetail",
    components: { credentials, afterSales, order, goods },
    watch: {
        modeValue: {
            immediate: true,
            handler: function (value) {
                console.log(value, "value");
            },
        },
    },
    data() {
        return {
            disabled: false,
            qualified: 1,
            activeName: "first",
            type: "approve", // view
            status: null,
            roleId: null,
            relationType: null,
            shopTypeName: null,
            shopName: null,
            orgCode: null,
            deptId: null,
            remarks: "",
            infoDetailData: {},
            queryScopeListData: [],
        };
    },
    methods: {
       
        back() {
            this.$router.go(-1);
        },
        submit() {
            let checkShopItemSession = window.sessionStorage.getItem('checkShopItemSession');
            if (checkShopItemSession) {  //缓存的检查项shopId和当前页面是一个
                checkShopItemSession = JSON.parse(checkShopItemSession)
                if (checkShopItemSession.shopId != this.$route.query.shopId) {
                    //缓存的检查项shopId和当前页面是 不是一个店铺
                    this.$message.error('请先选择检查意见！');
                    return;
                } else {
                    //缓存的检查项shopId和当前页面是一个
                    // this.$message.error('请先选择检查意见！')
                    // 如果四项都未检查，阻止提交
                    if (!checkShopItemSession.credentials.qualifiedSelect && !checkShopItemSession.goods.qualifiedSelect && !checkShopItemSession.order.qualifiedSelect && !checkShopItemSession.afterSales.qualifiedSelect) {
                        this.$message.error('请先选择检查意见！');
                        return; 
                    }else{
                        let params = checkShopItemSession;
                        saveCheckRecordDetails(params).then(res=>{
                            this.$message.success('提交成功！');
                            window.sessionStorage.removeItem("checkShopItemSession");
                            this.back()
                        }).catch(err=>{});
                    }
                } 
            } else {
                this.$message.error('请先选择检查意见！');
                return; 
            }

        },
        // 初始化缓存，本地如无此shopId缓存，存入一条缓存。此缓存为数组。
        initSeesion() {
            // 检查状态: 1-合格，2-不合格
            let shopItem = {
                shopId: this.$route.query.shopId,
                afterSales: {
                    qualifiedSelect: 0, //检查状态
                    remarks: '', //检查意见 
                },
                credentials: {
                    qualifiedSelect: 0,
                    remarks: '',
                },
                goods: {
                    qualifiedSelect: 0,
                    remarks: '',
                },
                order: {
                    qualifiedSelect: 0,
                    remarks: '',
                },
            }
            window.sessionStorage.setItem('checkShopItemSession', JSON.stringify(shopItem))
        }
    },
    mounted() {
        let checkShopItemSession = window.sessionStorage.getItem('checkShopItemSession');
        if (!checkShopItemSession) {
            this.initSeesion()
        } else if (checkShopItemSession && JSON.parse(checkShopItemSession).shopId != this.$route.query.shopId) {
            this.initSeesion()
        }
    },
};
</script>
<style lang="scss" scoped>
.filedsContainer {
    display: flex;
    flex-flow: column;
    height: 100%;
    overflow-y: auto;

    .head {
        background: #ffffff;
        height: 76px;
        padding: 10px 20px 0px 20px;
        line-height: 28px;
        display: flex;
        justify-content: space-between;
        border-bottom: solid 1px #F2F2F2;
    }

    .tabs {
        height: 60px;
    }

    .font-tip {
        padding-left: 20px;
        font-size: 12px;
    }

    .body {
        background: #ffffff;
        padding: 20px 20px 10px;
        display: flex;
        flex: 1;
        overflow-y: auto;
    }

    .chlidren {
        width: 100%;
    }

    .footer {
        padding: 20px 0 0;
        background: #ffffff;
    }

    .check-cotent {
        margin-top: 10px;
        //  width: calc(100% - 200px);
    }
}
</style>
  